import { withRouter } from 'react-router';
import { withUser } from 'components/queries/GetUserQuery';
import ImpulseUpgradeCta from './ImpulseUpgradeCta';

export default withUser(withRouter(ImpulseUpgradeCta));
